import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  makeBriefInfluencerQueryKey,
} from "../constants";
import {
  IBriefInfluencerV2,
  IInfluencerContact,
} from "@shared/lib/types/briefInfluencerV2";

export function useAddInfluencerPrimaryContact(
  briefId: string,
  onSuccess: (briefInfluencer: IBriefInfluencerV2) => void
) {
  const {
    mutate: addInfluencerPrimaryContact,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation({
    mutationFn: (data: {
      briefInfluencerId: string;
      contact: IInfluencerContact;
    }) =>
      BriefService.addInfluencerPrimaryContact(
        data.contact,
        data.briefInfluencerId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, data) => {
      onSuccess(data.data);
      ToastService.success("Primary contact updated successfully");
      c.invalidateQueries({ queryKey: makeBriefInfluencerQueryKey(briefId) });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    addInfluencerPrimaryContact,
    isAdding,
    isAdded,
  };
}
